import { useState } from "react";
import { useAlert } from "@/Common/CustomAlert/AlertContext";
import { saveBlogSubscriber } from "@/services/api/blog";
import {
  buildBlogSubscribePayload,
  createBlogSubscribeFormState,
  getBlogApiErrorMessage,
  isBlogApiSuccess,
  validateBlogSubscribeForm,
} from "@/utils/blogFormHelpers";
import styles from "./BlogSecTravelUpdate.module.css";

export default function BlogSecTravelUpdate() {
  const { showAlert } = useAlert();
  const [subscribeForm, setSubscribeForm] = useState(createBlogSubscribeFormState);
  const [subscribeErrors, setSubscribeErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const errors = validateBlogSubscribeForm(subscribeForm);
    if (Object.keys(errors).length > 0) {
      setSubscribeErrors(errors);
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await saveBlogSubscriber(
        buildBlogSubscribePayload(subscribeForm)
      );

      if (!isBlogApiSuccess(response)) {
        throw new Error(response?.message || "Unable to subscribe.");
      }

      showAlert({
        title: "Subscribed",
        message: response?.message || "You have subscribed successfully.",
      });
      setSubscribeForm(createBlogSubscribeFormState());
      setSubscribeErrors({});
    } catch (error) {
      showAlert({
        title: "Subscription failed",
        message: getBlogApiErrorMessage(error, "Unable to subscribe."),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className={`${styles.blogsecTravelUpdateSection} standard-padding`}>
      <div className={styles.blogsecTravelUpdateContainer}>
        <div className={styles.blogsecTravelUpdateHeader}>
          <h2 className="standard-heading">Be The First To Know </h2>
          <p className="standard-subheading">
            Sign up for exclusive deals, travel tips, and inspiration in your inbox.
          </p>
        </div>

        <form onSubmit={handleSubmit} className={styles.blogsecTravelUpdateForm} noValidate>
          <input
            type="email"
            placeholder="Enter your email address..."
            value={subscribeForm.emailId}
            onChange={(event) => {
              setSubscribeForm({ emailId: event.target.value });
              setSubscribeErrors({});
            }}
            className={`${styles.blogsecTravelUpdateInput} ${
              subscribeErrors.emailId ? styles.inputError : ""
            }`}
            disabled={isSubmitting}
          />
          <button
            type="submit"
            className={styles.blogsecTravelUpdateBtn}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Please wait..." : "Subscribe"}
          </button>
        </form>
        {subscribeErrors.emailId ? (
          <span className={styles.fieldError}>{subscribeErrors.emailId}</span>
        ) : null}
      </div>
    </section>
  );
}
